var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.599 6.697-3.856 3.668c-3.108-3.73-8.704-5.284-12.807-3.295-4.103 1.99-5.658 5.844-5.533 9.077.124 3.233 1.119 5.41 3.481 7.523 2.363 2.114 7.337 2.363 9.7 1.617 1.89-.597 4.227-2.736 5.16-3.73l3.854 3.73c-1.286 1.388-4.888 4.401-9.016 5.346-5.16 1.182-10.88-.621-13.864-3.543-2.985-2.923-5.098-6.902-4.663-12.124C2.492 9.744 5.04 3.402 14.118 1.35c7.262-1.64 13.346 2.88 15.48 5.347z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelr);
export default __webpack_public_path__ + "static/media/CELR.fc6c90359d00bc54d5ac67f24eab674c.svg";
export { ForwardRef as ReactComponent };